import { LABELS, NEW_ENDPOINTS } from '@constants'
import { useStore } from '@hooks/useStore'
import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import GenericImageUpload from 'src/components/features/outvoice-image-upload/OvImageUpload.component'
import { ImageUploadProvider } from 'src/components/features/outvoice-image-upload/OvImageUpload.context'

export const OvCompanyLogoUpload = observer(() => {
  const { company } = useStore()

  const uploadUrl = useMemo(
    () => (company?.company?.id ? NEW_ENDPOINTS.COMPANIES.LOGO(company.company.id) : undefined),
    [company?.company?.id]
  )

  const deleteUrl = useMemo(
    () => (company?.company?.id ? NEW_ENDPOINTS.COMPANIES.LOGO(company.company.id) : undefined),
    [company?.company?.id]
  )

  const handleDeleteLogo = async () => {
    try {
      await company.deleteLogo()
    } catch (e) {
      // Error already handled in store (toast shown or user cancelled)
      console.log('Logo deletion cancelled or failed')
    }
  }

  return (
    <ImageUploadProvider>
      {uploadUrl && (
        <GenericImageUpload
          title=""
          fieldName="logo"
          icon={null}
          changeButtonText={LABELS.LOGO_CHANGE}
          uploadButtonText={LABELS.LOGO_UPLOAD}
          deleteButtonText={LABELS.LOGO_DELETE}
          onUploadSuccess={({ data }) => {
            // Update the company store with the new logo data
            // current_company is a computed property that automatically reflects company
            company.set('company', data)
          }}
          onDelete={handleDeleteLogo}
          currentImageUrl={company.company?.logo_url || company.current_company?.logo_url}
          uploadUrl={uploadUrl}
          deleteUrl={deleteUrl}
          showCard={false}
        />
      )}
    </ImageUploadProvider>
  )
})
